import { useState, useEffect } from 'react';
import { i18nService, Language, t } from './i18nService';

// 国际化Hook，用于在组件中使用国际化功能
export const useI18n = () => {
  // 状态管理当前语言
  const [language, setLanguage] = useState<Language>(i18nService.getLanguage());

  // 语言变化时更新状态
  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(i18nService.getLanguage());
    };

    // 添加语言变化监听器
    i18nService.addListener(handleLanguageChange);

    // 清理函数
    return () => {
      i18nService.removeListener(handleLanguageChange);
    };
  }, []);

  // 切换语言的方法
  const changeLanguage = (lang: Language) => {
    i18nService.setLanguage(lang);
  };

  return {
    language,
    changeLanguage,
    t // 导出翻译函数
  };
};
